import {ClassificationFields} from '@/modules/drug-catalog/components/drug-item-form/classification-fields'
import {DrugItemFormOptions} from '@/modules/drug-catalog/constants'
import {MedicationProfilesSection} from '@/modules/drug-catalog/components/drug-item-form/medication-profiles-section'
import {MedicationProfileFormSchema} from '@/modules/drug-catalog/medication-profiles/schemas'
import {getSubstanceFormDefaultValues} from '@/modules/drug-catalog/substances/functions'
import {FormSection} from '@cypro/ui/components/form/form-section'
import {withForm} from '@cypro/ui/integrations/form'
import {useTranslate} from '@tolgee/react'
import {Box} from '@chakra-ui/react'
import {FormGrid} from '@cypro/ui/components'

export const EssentialSetupTab = withForm({
  ...DrugItemFormOptions,
  defaultValues: getSubstanceFormDefaultValues(undefined),
  props: {
    onAddMedicationProfile: () => {},
    onEditMedicationProfile: (_profile: MedicationProfileFormSchema, _index: number) => {},
    onDeleteMedicationProfile: (_index: number) => {},
  },
  render: function Render({form, onAddMedicationProfile, onEditMedicationProfile, onDeleteMedicationProfile}) {
    const {t} = useTranslate('common')
    const {t: tSubstances} = useTranslate('substances')

    return (
      <Box spaceY="8">
        <FormSection
          label={tSubstances('core_identity_classification')}
          description={tSubstances('core_identity_classification_description')}
        >
          <FormGrid>
            <form.AppField name="name">
              {field => (
                <field.TextField
                  size="sm"
                  label={t('official_name')}
                  placeholder={tSubstances('name_placeholder')}
                  required
                />
              )}
            </form.AppField>

            {/* @ts-expect-error */}
            <ClassificationFields form={form} />
          </FormGrid>

          <form.AppField name="additionalApprovalRequired">
            {field => (
              <field.CheckBox
                size="sm"
                label={t('requires_additional_approval')}
                description={t('adds_a_budget_authorization_step')}
              />
            )}
          </form.AppField>

          <form.AppField name="cytotoxic">
            {field => <field.CheckBox size="sm" label={t('cytotoxic')} description={t('cytotoxic_description')} />}
          </form.AppField>

          <form.AppField name="routeWarning">
            {field => (
              <field.CheckBox size="sm" label={t('route_warning')} description={t('route_warning_description')} />
            )}
          </form.AppField>
        </FormSection>

        <MedicationProfilesSection
          // @ts-expect-error
          form={form}
          onAddMedicationProfile={onAddMedicationProfile}
          onEditMedicationProfile={onEditMedicationProfile}
          onDeleteMedicationProfile={onDeleteMedicationProfile}
        />
      </Box>
    )
  },
})
